export const FETCH_FEED = "fetchFeed";
export const FETCH_PROSPECTIVE_FEED = "fetchProspectiveFeed";
export const FETCH_NESTED_FEED = "fetchNestedFeed";
export const FETCH_ENTITY = "fetchEntity";
export const CREATE_ENTITY = "createEntity";
export const SET_FILTERS = "setFilters";
export const SET_FORM_FIELD = "setFormField";
export const SET_FORM_STATE = "setFormState";
export const CLEAR_FORM = "clearForm";
export const REMOVE_ENTITY = "removeEntity";   
export const STAMP_ENTITY = "stampEntity"; 

export const LOADING = "loading";